import Button from "../../components/Buttons/button";
import { InfoCircle } from "@untitledui/icons/InfoCircle";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/modal.slice";
import { setMeData } from "../../redux/me.slice";
import { useNavigate } from "react-router-dom";
import { clearPendingSurvey } from "../../utils/pendingSurvey";
import { getAuthToken, removeAuthToken } from "../../utils/authToken";

const DeleteAccountModal = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const closePopup = () => {
    dispatch(closeModal({}));
  };
  const deleteUser = async () => {
    const token = getAuthToken();
    try {
      const response = await fetch(
        "https://backtoreality-api.codebnb.me/api/v1/current_user",
        {
          method: "DELETE",
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch(setMeData(null));
      navigation("/");
      removeAuthToken();
      clearPendingSurvey();
      closePopup();
    } catch (e) {}
  };
  return (
    <>
      <div className="modal-header">
        <div className="icon red">
          <InfoCircle />
        </div>
        <h4 className="mb-8">Delete Account</h4>
        <p className="text-color-grey">
          Are you sure? This will permanently delete your account and data.
        </p>
      </div>
      <div className="modal-body">
        <Button
          text={"Delete"}
          type={"red"}
          className={"mb-12"}
          fullWidth={true}
          onClick={deleteUser}
        />
        <Button
          text={"Cancel"}
          type={"outline"}
          fullWidth={true}
          onClick={closePopup}
        />
      </div>
    </>
  );
};

export default DeleteAccountModal;
